import React from 'react';
import { Switch, Redirect, HashRouter } from 'react-router-dom';

import { collaborationRoutes } from './routes';
import AppHeader from 'components/common/app-header';
import PrivateRoute from './private-route';

export const renderRouter = () => {
  return (
    <HashRouter>
      <AppHeader />
      <div style={{ marginTop: '40px' }}>
        <Switch>{generateRoutes(collaborationRoutes)}</Switch>
      </div>
    </HashRouter>
  );
};

export const generateRoutes = (routes) => {
  let processedRoutes = [];
  Object.values(routes).forEach((rt) => {
    processedRoutes.push(
      <PrivateRoute key={rt.path} exact path={rt.path}>
        {rt.component}
      </PrivateRoute>,
    );

    processedRoutes.push(...generateRedirects(rt.redirects || [], rt.path));
  });

  return processedRoutes;
};

export const generateRedirects = (redirects, navRoute) => {
  return redirects.map((rd) => (
    <Redirect key={rd} exact from={rd} to={navRoute} />
  ));
};
